<template>
  <div>
    <div>
      <b-row no-gutters>
        <b-col>
          <DesignNav></DesignNav>
        </b-col>
      </b-row>
    </div>
    <div>
      <div class="content-body">
        <div class="content-inside">
          <div class="row no-gutters">
            <div class="col">
              <h5>Banner Image</h5>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-4">
              <div class="boxes">
                <router-link to="estorebanner/create-banner">
                  <div class="create-box mr-4 mb-4">
                    <img src="@/assets/images/icons/add.svg" alt />
                    <span style="color: #ff8828">Create</span>
                  </div>
                </router-link>
              </div>
            </div>
            <div class="col-lg-8" v-if="featuredBannerList">
              <div class="row">
                <div
                  class="col"
                  v-for="(list, index) in featuredBannerList.designs"
                  :key="index"
                >
                  <div class="boxes mb-4">
                    <div class="banner-box">
                      <div class="header mb-2">
                        <span style="color: #ff8828" v-if="list.published == 1"
                          >Published</span
                        >
                        <span style="color: #ff8828" v-else>Draft</span>
                        <switches
                          v-model="list.published"
                          theme="custom"
                          color="primary"
                          type-bold="true"
                          text-enabled="On"
                          text-disabled="Off"
                          style="margin: -14px 12px 0px; padding: 0"
                          @click.native="publishDesign(list.uuid, index)"
                        ></switches>
                        <router-link
                          :to="'estorebanner/edit-banner/' + list.uuid"
                        >
                          <img
                            src="../../assets/images/actions/edit.svg"
                            alt="Edit Icon"
                            class="mx-2"
                            style="cursor: pointer"
                          />
                        </router-link>
                        <img
                          src="../../assets/images/actions/delete.svg"
                          alt="Delete Icon"
                          style="cursor: pointer"
                          @click="showModal(list.uuid, list.title)"
                        />
                      </div>
                      <div class="body mb-2">
                        <div
                          class="banner-container"
                          style="width: 260px; height: 109px"
                        >
                          <img
                            :src="getDefaultBanner(list)"
                            alt="Featured Banner"
                            width="260"
                            height="109"
                            style="object-fit: cover;"
                          />
                        </div>
                      </div>
                      <div class="footer">
                        <span
                          class="d-block mb-2"
                          style="font-size: 14px; font-family: MainFontBold, sans-serif; font-weight: normal"
                          >{{ list.title }}</span
                        >
                        <span class="d-block" style="font-size: 12px"
                          >Last edited: {{ list.updated_at }}</span
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-modal ref="delete-modal" title="Delete Banner">
      <p class="modal-main-message">Are you sure you want delete this banner?</p>
      <h3 class="modal-secondary-message">{{ bannerName }}</h3>
      <div slot="modal-footer">
        <b-btn variant="ghost" class="mr-1 btn-cancel" @click="hideModal()">
          Cancel
        </b-btn>
        <b-btn variant="primary" class="ml-1" @click="removeBanner(bannerUuid)">
          Yes, Delete
        </b-btn>
      </div>
    </b-modal>
  </div>
</template>

<script>
import DesignNav from "./components/DesignNav";
import Switches from "vue-switches";
import { mapState } from "vuex";

export default {
  components: {
    DesignNav,
    Switches,
  },
  computed: {
    ...mapState("designs", {
      loading: (state) => state.loading,
      errors: (state) => state.errors,
      details: (state) => state.details,
      featuredBannerList: (state) => state.featuredBannerList,
    }),
  },
  created() {
    this.getFeaturedBannerList();
  },
  data() {
    return {
      banner: true,
      bannerUuid: null,
      bannerName: null
    };
  },
  methods: {
    getDefaultBanner(item) {
      if (item.app_image_show && item.app_image)
        return item.app_image;
      if (item.web_image_show && item.web_image)
        return item.web_image;
      if (item.gcash_image_show && item.gcash_image)
        return item.gcash_image;

      return "";
    },
    async getFeaturedBannerList() {
      await this.$store.dispatch("designs/getFeaturedBannerList");
    },
    showModal(uuid, title) {
      this.$refs["delete-modal"].show();
      this.bannerUuid = uuid;
      this.bannerName = title;
    },
    hideModal(modal) {
      this.$refs["delete-modal"].hide();
    },
    async removeBanner(uuid) {
      await this.$store
        .dispatch("designs/deleteFeatureBanner", uuid)
        .then(() => {
          this.$store.dispatch("designs/getFeaturedBannerList");
          this.hideModal();
          this.bannerUuid = null;
          this.bannerName = null;
        });
    },
    async publishDesign(uuid, index) {
      let param = {
        uuid: uuid,
        published: !this.featuredBannerList.designs[index].published,
      };

      await this.$store.dispatch("designs/publishDesign", param).then(() => {
        this.$store.dispatch("designs/getFeaturedBannerList");
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.boxes {
  // display: flex;

  .create-box {
    border: 1px dashed #ced4df;
    box-sizing: border-box;
    border-radius: 4px;
    width: 300px;
    height: 139px;

    display: flex;
    flex-flow: column;
    justify-content: center;
    align-items: center;
  }

  .banner-box {
    background: #f8f8f9;
    border-radius: 4px;
    width: 300px;
    height: 233px;
    padding: 15px 18px;

    .header {
      display: flex;

      span {
        flex: 1;
      }
    }
  }
}
</style>